import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import thunk from 'redux-thunk';
import movieListReducer from './reducers/movieListReducer';
import userLoginReducer from './reducers/userLoginReducer';
// import rootReducers from "./reducers/index";
// const middleware = applyMiddleware(thunk);
// const { appReducer } = rootReducers();

const rootReducer = combineReducers({
  movie: movieListReducer,
  userLogin: userLoginReducer,
});
const userTokenFromStorage = localStorage.getItem('token')
  ? JSON.parse(localStorage.getItem('token'))
  : null;
const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;

const initialState = {
  userLogin: { token: userTokenFromStorage, userInfo: userInfoFromStorage },
};

const middleware = [thunk];

const store = configureStore({
  reducer: rootReducer,
  // preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(...middleware),
});

export default store;
